<template>
  <table class="m3p-modal__table">
    <tbody>
      <tr>
        <th>お名前</th>
        <td colspan="3">{{ fullName }}</td>
      </tr>
      <tr>
        <th>ふりがな</th>
        <td colspan="3">{{ fullNameKana }}</td>
      </tr>
      <tr>
        <th>メールアドレス</th>
        <td colspan="3">{{ formData.email }}</td>
      </tr>
      <tr>
        <th>現住所</th>
        <td colspan="3">{{ address }}</td>
      </tr>
      <tr>
        <th>電話番号</th>
        <td colspan="3">{{ formData.phone }}</td>
      </tr>
      <tr>
        <th v-if="sex">性別</th>
        <td v-if="sex">{{ sex }}</td>
        <th>生まれた年</th>
        <td :colspan="sex ? 1 : 3">{{ age }}</td>
      </tr>
      <tr>
        <th>転職希望時期</th>
        <td :colspan="workStatus ? 1 : 3">{{ wishfulTime }}</td>
        <th v-if="workStatus">就業状況</th>
        <td v-if="workStatus">{{ workStatus }}</td>
      </tr>
      <tr v-if="experiences.length > 0">
        <th>経験年数</th>
        <td colspan="3">
          <p v-for="(experience, idx) in experiences" :key="idx">
            {{ experience }}
          </p>
        </td>
      </tr>
      <tr>
        <th>メッセージ</th>
        <td colspan="3">
          <span id="one_click_inquiry_message_view">{{
            formData.message
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script setup>
import AgeParts from '@component_path/lib/ageParts';
import { computed } from 'vue';

const props = defineProps({
  masterData: {
    type: Object,
    required: true
  },
  formData: {
    type: Object,
    required: true
  }
});

const fullName = computed(() => props.formData.name);
const fullNameKana = computed(() => props.formData.name_kana);
const address = computed(() => {
  const selectedPrefecture = props.masterData.prefectures.find(
    prefectureMaster => prefectureMaster.code === props.formData.prefecture_id
  );
  return `${selectedPrefecture.text} ${props.formData.address || ''}`;
});
const sex = computed(() => {
  const sexMasterdata = { 1: '男性', 2: '女性' };
  return sexMasterdata[props.formData.sex];
});
const age = computed(() => {
  const selectedAge = AgeParts.createBirthYears().find(
    age => age.value === props.formData.age
  );
  return selectedAge ? selectedAge.text : '';
});
const wishfulTime = computed(() => {
  const selectedWishfulTime = props.masterData.wishful_times.find(
    wishfulTimeMaster =>
      wishfulTimeMaster.code === props.formData.wishful_time.toString()
  );
  return selectedWishfulTime.name;
});
const workStatus = computed(() => {
  const workStatusMasterdata = { 1: '在籍中', 2: '離職中' };
  return workStatusMasterdata[props.formData.work_status];
});
const experiences = computed(() => {
  const experiencesAttributes = props.formData.experiences_attributes;

  return Object.keys(experiencesAttributes).map(key => {
    const positionType = props.masterData.position_types.find(
      positionType =>
        positionType.code === experiencesAttributes[key].position_type
    ).name;
    const year = props.masterData.experience_years.find(
      experienceYear =>
        experienceYear.value.toString() === experiencesAttributes[key].year
    ).text;
    return `${positionType} ${year}`;
  });
});
</script>
